import {
  Component, OnInit, Inject, ChangeDetectorRef, ChangeDetectionStrategy,
} from '@angular/core';

interface Badge {
  id: string;
  name: string;
  description: string;
  points: number;
  icon: string;
  type?: string;
}

@Component({
  selector: 'ut-gamification',
  templateUrl: './gamification.component.html',
  styleUrls: ['./gamification.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class GamificationComponent implements OnInit {
  badges: Badge[] = [];
  private myBadges: string[] = [];

  constructor(
    private cdr: ChangeDetectorRef,
    @Inject('GamificationService') private GamificationService: any,
    @Inject('UserService') private UserService: any,
  ) {}

  ngOnInit(): void {
    // Load all badges
    this.GamificationService.all().then((badges: Badge[]) => {
      this.badges = badges;
      this.cdr.markForCheck();
    });

    // Load user's earned badges
    this.UserService.me().then((res: any) => {
      if (res !== null && res.data && res.data.badges) {
        this.myBadges = res.data.badges.map((b: any) => b.badge_type);
        this.cdr.markForCheck();
      }
    });
  }

  checkDone(badgeId: string): boolean {
    return this.myBadges.indexOf(badgeId) >= 0;
  }
}
